<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz"><b>Constellations</b></span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
<div style="text-align:center"><img alt="Echoes-of-Earth-Diagram-Three" src="images/Echoes-of-Earth-Diagram-Three.png"/></div>
<p class="p3"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section6.vue?3293f231